import { FiFileText, FiSearch, FiTarget } from 'react-icons/fi';

export const PRODUCT_TUTORIAL_COPY = {
  en: {
    help: 'Help',
    close: 'Close tutorial',
    skip: 'Skip introduction',
    back: 'Back',
    next: 'Next',
    finish: 'See my opportunities',
    gotIt: 'Got it',
    step: 'Step {current} of {total}',
    previews: {
      scout: { label: 'Jobs selected for you', match: 'match', roles: [['Product Marketing Manager', 'Northstar · New York'], ['Content Strategy Lead', 'Luma · Remote'], ['Growth Marketing Manager', 'Horizon · Boston']] },
      application: { label: 'Your application', role: 'Senior Marketing Manager', company: 'Northstar', items: ['Job details', 'Tailored CV created', 'Cover letter created', 'Hiring team found'] },
      system: { goal: 'Weekly goal', goalValue: '3 of 5 applications', coach: 'Career Coach', coachValue: 'Ready to help', radar: 'Company Radar', radarValue: '4 companies', learning: 'Learning Pathway', learningValue: '42% complete' },
      coachOverview: { label: 'Your Career Coach', focus: 'Your main focus', focusValue: 'Move into a senior marketing role', goal: 'Weekly goal', goalValue: '3 of 5 applications completed' },
      coachAsk: { label: 'Ask Me Anything', question: 'Should I accept this offer or keep looking?', answer: 'This offer moves you toward your target role, but the salary is below the range you set. I would negotiate before accepting.', knows: ['Your CV and skills', 'Your target roles', 'Your goals and locations', 'Your recent conversation'], value: 'Personal coaching can cost $100+/hour' },
      coachCv: { label: 'CV created with your Coach', title: 'Product Marketing CV', sections: ['Experience rewritten clearly', 'Skills matched to your target role', 'Achievements made more specific'], saved: 'Complete CV saved to your profile' },
      careerPaths: { label: 'Your next moves', roles: [['Senior Marketing Manager', 'Strong fit · Growing'], ['Product Marketing Manager', 'Strong fit · Growing'], ['Brand Director', 'Promising fit · Steady']] },
      scoutEdit: { label: 'What your Scout searches for', items: [['Preferred roles', 'Marketing Manager'], ['Locations', 'New York · Boston'], ['Work mode', 'Hybrid · Remote'], ['Priorities', 'Full-time roles']] },
      coachInterview: { label: 'Voice interview practice', question: 'Tell me about a campaign you changed after the results were weaker than expected.', result: 'Clear feedback after every answer' },
      inboxMessages: { label: 'Messages', role: 'Senior Marketing Manager', company: 'Northstar', recruiter: 'Maya · Talent Partner', messages: ['Thanks for applying. Are you available Thursday?', 'Yes, Thursday afternoon works for me.'] },
      inboxOutreach: { label: 'Outreach', role: 'Senior Marketing Manager', company: 'Northstar', contacts: '2 hiring-team contacts', sent: 'Introduction sent', next: 'Next follow-up in 2 days', controls: ['Pause', 'Stop'] },
    },
    slides: [
      {
        eyebrow: 'YOUR JOB SCOUT',
        title: 'Let suitable jobs come to you',
        body: 'Your Scout uses your CV, preferred roles and locations to find jobs automatically and rank the strongest matches first.',
        points: ['Jobs selected for your experience', 'Your preferred roles and locations', 'Better matches shown first'],
        icon: FiSearch,
      },
      {
        eyebrow: 'EVERY APPLICATION',
        title: 'Apply with everything prepared',
        body: 'Open a job to apply. With Pro, JOBSEEQR creates a tailored CV and cover letter for that job and helps you contact the hiring team.',
        points: ['A tailored CV', 'A tailored cover letter', 'Hiring-team outreach'],
        icon: FiFileText,
      },
      {
        eyebrow: 'YOUR CAREER SYSTEM',
        title: 'Keep moving toward the right role',
        body: 'Set weekly goals, ask your Career Coach for guidance, follow target companies, build missing skills and practice interviews.',
        points: ['Clear weekly goals', 'Career guidance when you need it', 'Tools for skills, companies and interviews'],
        icon: FiTarget,
      },
    ],
  },
  ar: {
    help: 'مساعدة',
    close: 'إغلاق الدليل',
    skip: 'تخطي المقدمة',
    back: 'رجوع',
    next: 'التالي',
    finish: 'عرض فرصي',
    gotIt: 'فهمت',
    step: 'الخطوة {current} من {total}',
    previews: {
      scout: { label: 'وظائف مختارة لك', match: 'تطابق', roles: [['مدير تسويق المنتجات', 'نورث ستار · نيويورك'], ['قائد استراتيجية المحتوى', 'لوما · عن بُعد'], ['مدير تسويق النمو', 'هورايزن · بوسطن']] },
      application: { label: 'طلبك', role: 'مدير تسويق أول', company: 'نورث ستار', items: ['تفاصيل الوظيفة', 'تم إنشاء السيرة الذاتية', 'تم إنشاء رسالة التعريف', 'تم العثور على فريق التوظيف'] },
      system: { goal: 'الهدف الأسبوعي', goalValue: '3 من 5 طلبات', coach: 'المدرب المهني', coachValue: 'جاهز للمساعدة', radar: 'رادار الشركات', radarValue: '4 شركات', learning: 'مسار التعلّم', learningValue: 'مكتمل بنسبة 42٪' },
      coachOverview: { label: 'مدربك المهني', focus: 'تركيزك الرئيسي', focusValue: 'الانتقال إلى منصب مدير تسويق أول', goal: 'الهدف الأسبوعي', goalValue: 'تم إكمال 3 من 5 طلبات' },
      coachAsk: { label: 'اسألني أي شيء', question: 'هل أقبل هذا العرض أم أواصل البحث؟', answer: 'يقربك هذا العرض من الوظيفة التي تستهدفها، لكن الراتب أقل من النطاق الذي حددته. أنصحك بالتفاوض قبل القبول.', knows: ['سيرتك ومهاراتك', 'الوظائف التي تستهدفها', 'أهدافك ومواقعك', 'محادثتك الأخيرة'], value: 'قد يكلف المدرب الشخصي أكثر من 100 دولار للساعة' },
      coachCv: { label: 'سيرة ذاتية أنشأتها مع مدربك', title: 'سيرة لتسويق المنتجات', sections: ['إعادة كتابة الخبرة بوضوح', 'مطابقة المهارات مع الوظيفة المستهدفة', 'توضيح الإنجازات بشكل أدق'], saved: 'تم حفظ السيرة الكاملة في ملفك' },
      careerPaths: { label: 'خطواتك التالية', roles: [['مدير تسويق أول', 'ملاءمة قوية · نمو'], ['مدير تسويق المنتجات', 'ملاءمة قوية · نمو'], ['مدير العلامة التجارية', 'ملاءمة واعدة · مستقر']] },
      scoutEdit: { label: 'ما يبحث عنه مساعدك', items: [['الوظائف المفضلة', 'مدير تسويق'], ['المواقع', 'نيويورك · بوسطن'], ['نمط العمل', 'هجين · عن بُعد'], ['الأولويات', 'وظائف بدوام كامل']] },
      coachInterview: { label: 'تدريب صوتي على المقابلة', question: 'حدثني عن حملة غيّرت خطتها بعد أن كانت النتائج أضعف من المتوقع.', result: 'ملاحظات واضحة بعد كل إجابة' },
      inboxMessages: { label: 'الرسائل', role: 'مدير تسويق أول', company: 'نورث ستار', recruiter: 'مايا · مسؤولة المواهب', messages: ['شكراً لتقديمك. هل يناسبك يوم الخميس؟', 'نعم، يناسبني عصر الخميس.'] },
      inboxOutreach: { label: 'التواصل', role: 'مدير تسويق أول', company: 'نورث ستار', contacts: 'شخصان من فريق التوظيف', sent: 'تم إرسال رسالة التعريف', next: 'المتابعة القادمة بعد يومين', controls: ['إيقاف مؤقت', 'إيقاف نهائي'] },
    },
    slides: [
      {
        eyebrow: 'مساعد البحث عن الوظائف',
        title: 'دع الوظائف المناسبة تصل إليك',
        body: 'يستخدم مساعدك سيرتك الذاتية والوظائف والمواقع التي تفضلها ليعثر على الوظائف تلقائياً ويعرض أفضلها أولاً.',
        points: ['وظائف تناسب خبرتك', 'الوظائف والمواقع التي تفضلها', 'أفضل النتائج تظهر أولاً'],
        icon: FiSearch,
      },
      {
        eyebrow: 'كل طلب توظيف',
        title: 'تقدّم وكل شيء جاهز',
        body: 'افتح أي وظيفة للتقدم إليها. مع Pro، ينشئ JOBSEEQR سيرة ذاتية ورسالة تعريف مخصصتين للوظيفة ويساعدك على التواصل مع فريق التوظيف.',
        points: ['سيرة ذاتية مخصصة', 'رسالة تعريف مخصصة', 'التواصل مع فريق التوظيف'],
        icon: FiFileText,
      },
      {
        eyebrow: 'نظامك المهني',
        title: 'استمر في التقدم نحو الوظيفة المناسبة',
        body: 'حدد أهدافاً أسبوعية، واسأل مدربك المهني، وتابع الشركات المستهدفة، وطوّر مهاراتك، وتدرّب على المقابلات.',
        points: ['أهداف أسبوعية واضحة', 'إرشاد مهني عند الحاجة', 'أدوات للمهارات والشركات والمقابلات'],
        icon: FiTarget,
      },
    ],
  },
};
